export enum MultiplierType {
  effectiveness = 'effectiveness',
  roi = 'roi'
}
